import * as React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { PageTitle, SectionHeader } from '@/components/common';
import { FourPhases, TheMethod } from '@/components/marketing';

const MethodPage: NextPage = () => {
  return <>
      <NextSeo description="You are a mystery. Your body doesn't have to be." title='Method' />
      <PageTitle>Method</PageTitle>
      <section className='mb-8 md:mb-12'>
        <SectionHeader className='mb-8 md:mb-12' description="You are a mystery. Your body doesn't have to be." headingChildren={<h3 className='font-lato text-2xl md:text-3xl uppercase tracking-tight font-bold bg-clip-text text-transparent bg-gradient-yellow-to-purple'>
              Your Four Phases
            </h3>} image='/icons/atoms.svg' />
        <FourPhases />
      </section>
      <section>
        <SectionHeader className='mb-8 md:mb-12' description='28 is a rejuvenating, stability-based approach to feminine fitness designed by supermodel trainers and medical experts to work with your natural cycle.' headingChildren={<h3 className='font-lato text-2xl md:text-3xl uppercase tracking-tight font-bold bg-clip-text text-transparent bg-gradient-yellow-to-purple'>
              The Approach
            </h3>} image='/icons/atoms.svg' />
        <TheMethod />
      </section>
    </>;
};

export default MethodPage;